<template>
    <div class="autocal padding-top-15 clearfix">
        <vTable border :data="tableData" :columns="columns" @on-radio-change="handleSelect"></vTable>
        <div class="recommand padding-top-15 padding-bottom-15">
            推荐仓库：<span class="font-bold">{{recommandWarehouse}}</span>
        </div>
        <div class="button-container pull-right">
            <Button type="primary" @click="confirm">确定</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpAutoCalculateWarehouse
} from "@/service/inbound";
export default {
    props: ["id", "areaId"],
    data () {
        return {
            recommandWarehouse: "",
            tableData: [],
            loading: false
        }
    },
    async created () {
        this.loading = true;
        await HttpAutoCalculateWarehouse({
            id: this.id,
            areaId: this.areaId
        }).then(res => {
            this.tableData = res.data.list;
        }, err => {
            this.$VMessage.error(err.message);
        });
        this.loading = false;
    },
    computed: {
        getBussinessTypeMap () {
            return [
                {
                    value: 1,
                    label: "B2B"
                },
                {
                    value: 2,
                    label: "B2C"
                },
                {
                    value: 3,
                    label: "待定"
                }
            ]
        },
        columns () {
            return [
                {
                    type: "selection",
                    width: 50,
                    align: "center",
                    isRadio: true,
                },
                {
                    title: "区域仓",
                    key: "orgWarehouseCode",
                },
                {
                    title: "业务模式",
                    key: "bussinessType",
                    render: (h, { row }) => {
                        let textArr = row.bussinessType.map(rowItem => {
                            return this.getBussinessTypeMap.filter(bussinessTypeItem => {
                                return bussinessTypeItem.value == rowItem;
                            })[0].label;
                        });
                        let className = "color-error";
                        if (row.type) {
                            className = "";
                        }
                        return <div class={className}>{textArr.join(',')}</div>
                    }
                },
                {
                    title: "入库处理能力",
                    key: "inboundHandle",
                    render: (h, { row }) => {
                        return <div class={row.inboundHandle ? "" : "color-error"}>{row.inboundHandle ? "Y" : "N"}</div>
                    }
                },
                {
                    title: "SKU种类匹配度",
                    key: "skuMatch",
                    render: (h, { row }) => {
                        return <div>{row.skuMatch}%</div>
                    }
                },
                {
                    title: "可用库容/整仓可用库容(CBM)",
                    key: "capacity",
                    render: (h, { row }) => {
                        return <div><span class={row.checkCapacity ? "" : "color-error"}>{row.capacity}</span>/{row.allCapacity}</div>
                    }
                },
                {
                    title: "出库处理能力",
                    key: "outboundHandle",
                    render: (h, { row }) => {
                        return <div class={row.outboundHandle ? "" : "color-error"}>{row.outboundHandle ? "Y" : "N"}</div>
                    }
                }
            ]
        }
    },
    methods: {
        handleSelect (row) {
            this.orgWarehouseId = row.orgWarehouseId;
        },
        confirm () {
            this.$emit('on-select-warehouse', this.orgWarehouseId);
        }
    },
}
</script>

<style>

</style>